// extracted by mini-css-extract-plugin
export default {"overlay":"loadingOverlay_overlay__-mm2x","content":"loadingOverlay_content__6FDAn","spinner":"loadingOverlay_spinner__OgVau","spin":"loadingOverlay_spin__vLDBv"};